/** @format */
import { useEffect } from 'react';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
interface WindowWithEmbedly extends Window {
    embedly?: any;
}

export const useEmbedlyState = (): [boolean, () => void] => {
    const hasWindow = typeof window !== 'undefined';
    const win: WindowWithEmbedly | undefined = hasWindow ? window : undefined;

    const shouldLoadEmbedlyScript =
        hasWindow && typeof win?.embedly === 'undefined';

    /**
     * Handles embedly embeds, invoking their card behaviour
     * against the DOM, looking for .embedly-card
     */
    function processEmbeds() {
        // Render any embedly cards
        win?.embedly?.('card', '.embedly-card');
    }

    useEffect(() => {
        processEmbeds();
    }, []);

    return [shouldLoadEmbedlyScript, processEmbeds];
};
